import { Component, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { EqBaseComponent } from '../eq-base/eq-base.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { SeperatorComponent } from '../seperator/seperator.component';
const Material = [
  MatFormFieldModule,
  MatRippleModule,
  MatIconModule,
  MatSelectModule,
];
@Component({
  selector: 'eq-dropdown-multi-label',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeperatorComponent,
    ...Material
  ],
  templateUrl: './dropdown-multi-label.component.html',
  styleUrl: './dropdown-multi-label.component.scss',
  encapsulation: ViewEncapsulation.None

})
export class MultiLabelDropdownComponent extends EqBaseComponent {
  @Input() options: any = [
    { label: "Default", value: "default", isDisable: false },
  ]
  @Input() multiSelect: boolean = false;

  getKeys(obj: any): Array<string> {
    return Object.keys(obj);
  }
}
